import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FD150M, FD151M)
// ============================================================

export interface FD151M {
  fd151_01: string;   // 領用單號 (FK→FD150M)
  fd151_02: number;   // 序號
  fd151_10: string;   // 產品代號前段
  fd151_11: string;   // 產品代號後段
  fd151_12: string;   // 批號
  fd151_13: string;   // 庫存單位
  fd151_14: string;   // 託工單位
  fd151_15: number;   // 現有庫存量 (單價)
  fd151_16: number;   // 領用量
  fd151_17: number;   // 金額
  fd151_18: number;   // 備用
  fd151_19: number;   // 備用
  fd151_20: number;   // 備用
  fd151_21: number;   // 單位換算率
  fd151_90: number;   // 版次
}

export interface FD150M {
  fd150_01: string;         // 領用單號
  fd150_10: string;         // 部門代號
  fd150_11: string;         // 託工單號
  fd150_12: string | null;  // 領用日期
  fd150_13: string;         // 領用庫位
  fd150_14: string;         // 備注 (收布編號)
  fd150_15: string;         // 備用
  fd150_16: boolean;        // 備用
  fd150_17: boolean;        // 備用
  fd150_18: number;         // 總領用量
  fd150_19: number;         // 備用
  fd150_20: number;         // 備用
  fd150_21: number;         // 總領用金額
  fd150_22: number;         // 總項數
  fd150_23: string | null;  // 備用日期
  fd150_24: string | null;  // 備用日期
  fd150_25: string;         // 建檔人員
  fd150_26: boolean;        // 重修再入庫
  fd150_27: boolean;        // 備用
  fd150_28: string | null;  // 備用日期
  fd150_80: string;         // 核准狀態 ('' | 'P')
  fd150_87: string;         // 備用
  fd150_88: string | null;  // 備用日期
  fd150_89: string;         // 備用
  fd150_90: number;         // 版次
  fd150_91: string;         // 修改人員
  fd150_92: string | null;  // 修改日期
  fd150_93: string;         // 修改時間
  details?: FD151M[];
}

export interface CreateRequest {
  master: Omit<FD150M, 'details'>;
  details: FD151M[];
}

export interface UpdateRequest {
  master: Omit<FD150M, 'details'>;
  details: FD151M[];
}

export interface ListResponse {
  data: FD150M[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Client
// ============================================================

export const d205Api = {
  list(page = 1, pageSize = 20): Promise<ListResponse> {
    return apiClient
      .get('/api/d205', { params: { page, pageSize } })
      .then((r) => r.data);
  },

  get(id: string): Promise<FD150M> {
    return apiClient.get(`/api/d205/${id}`).then((r) => r.data);
  },

  create(req: CreateRequest): Promise<FD150M> {
    return apiClient.post('/api/d205', req).then((r) => r.data);
  },

  update(id: string, req: UpdateRequest): Promise<FD150M> {
    return apiClient.put(`/api/d205/${id}`, req).then((r) => r.data);
  },

  delete(id: string): Promise<void> {
    return apiClient.delete(`/api/d205/${id}`).then(() => undefined);
  },

  // Approval workflow
  submitForApproval(id: string, comment?: string): Promise<{ message: string }> {
    return apiClient.post(`/api/d205/${encodeURIComponent(id)}/submit`, { comment: comment || '' }).then(r => r.data);
  },

  approve(id: string, comment?: string): Promise<{ message: string }> {
    return apiClient.post(`/api/d205/${encodeURIComponent(id)}/approve`, { comment: comment || '' }).then(r => r.data);
  },

  reject(id: string, comment?: string): Promise<{ message: string }> {
    return apiClient.post(`/api/d205/${encodeURIComponent(id)}/reject`, { comment: comment || '' }).then(r => r.data);
  },

  writeoff(id: string, comment?: string): Promise<{ message: string }> {
    return apiClient.post(`/api/d205/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' }).then(r => r.data);
  },

  getApprovalHistory(id: string): Promise<unknown[]> {
    return apiClient.get(`/api/d205/${encodeURIComponent(id)}/approval-history`).then(r => r.data);
  },
};
